// import '../App.css';
// import stars from '../assets/images/stars.png';

import React, { useEffect, useState } from "react";
import { motion } from "framer-motion";
import "../App.css";

function Rating() {
  const [acf, setAcf] = useState(null);
  const [showBooking, setShowBooking] = useState(false);

  useEffect(() => {
    fetch("https://family-barbers.com/wp-json/acf/v3/pages/14")
      .then((res) => res.json())
      .then((json) => setAcf(json.acf))
      .catch((err) => console.error("Error fetching ACF data:", err));
  }, []);

  if (!acf) return null;

  return (
    <div
      id="rating"
      className="section"
      style={{
        backgroundImage: acf.rating_background_image
          ? `linear-gradient(rgba(0, 0, 0, 0.6), rgba(0, 0, 0, 0.6)), url(${acf.rating_background_image.url})`
          : "none",
      }}
    >
      <div className="rating-parent-container">
        <h1>{acf.rating_title}</h1>

        {acf.rating_stars && (
          <motion.img
            src={acf.rating_stars.url}
            alt={acf.rating_stars.alt || "Customer rating stars"}
            initial={{ y: 600, opacity: 0 }}
            whileInView={{ y: 0, opacity: 1 }}
            viewport={{ once: true, amount: 0.3 }} // triggers when 30% visible
            transition={{
              type: "spring",
              stiffness: 200,
              damping: 10,
              duration: 1
            }}
          />
        )}

        <div className="rating-child-container">
          {[acf.rating_review_1, acf.rating_review_2, acf.rating_review_3, acf.rating_review_4]
            .filter(Boolean)
            .map((review, i) => (
              <div key={i} className="rating-child-div">
                <p>{review}</p>
              </div>
            ))}
        </div>

        {acf.rating_button_text && (
          <button
            className="schedule-appointment rating-button"
            onClick={() => {
              if (window.innerWidth < 1024) {
                // On small screens, go straight to booking page
                window.open("https://getsquire.com/booking/brands/family-barbers", "_blank");
              } else {
                // On desktop, toggle the popup modal
                setShowBooking(!showBooking);
              }
            }}
          >
            <span className="schedule-appointment-text">
              {acf.rating_button_text}
            </span>
          </button>
        )}

        {/* Booking Popup */}
        {showBooking && (
          <div className="booking-modal">
            <div className="booking-content">
              <button className="close-btn" onClick={() => setShowBooking(!showBooking)}>
                ✖
              </button>
              <iframe
                src="https://getsquire.com/booking/brands/family-barbers"
                style={{ width: "100%", height: '95vh', border: "none" }}
                title="Squire Booking"
              ></iframe>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

export default Rating;

